import { useState } from 'react';
import { ModalCWShellUI } from '@next-order/next-order-components';
import exclamationMark from '../../assets/images/exclamationmark.svg';

export default function PaymentErrorModal({ closeModal }) {
  const [isOpen, setIsOpen] = useState(true);
  return (
    <ModalCWShellUI maxWidth={460} open={isOpen} zIndex={9999} maxHeight='full'>
      <ModalCWShellUI.Body>
        <div className='flex flex-col items-start gap-y-2'>
          <div>
            <img src={exclamationMark} alt='error' className='h-[20px]' />
          </div>
          <span className='redSpan text-[14px] font-medium'>
            Sorry, your payment didn't go through.
          </span>

          <span className='text-[14px]'>
            Please double check your card details or try a different payment
            method.
          </span>
          <span className='text-[14px]'>
            If the issue persists, contact your card issuer and try again later.
          </span>
        </div>
      </ModalCWShellUI.Body>
      <ModalCWShellUI.Footer>
        <ModalCWShellUI.Button
          onClick={() => {
            setIsOpen(false);
            closeModal();
          }}
        >
          Retry
        </ModalCWShellUI.Button>
      </ModalCWShellUI.Footer>
    </ModalCWShellUI>
  );
}
